module.exports = __webpack_public_path__ + "img/firstEdition4.bce76440.png";